"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePrivateKey = void 0;
const constants_1 = require("../constants");
const lit_actions_client_1 = require("../lit-actions-client");
const utils_1 = require("../lit-actions-client/utils");
const service_client_1 = require("../service-client");
const utils_2 = require("../utils");
function getKeyTypeFromNetwork(network) {
    if (network === constants_1.NETWORK_EVM) {
        return 'K256';
    }
    else if (network === constants_1.NETWORK_SOLANA) {
        return 'ed25519';
    }
    else {
        throw new Error('Network not implemented in generate-private-key');
    }
}
/**
 * Generates a random private key inside a Lit Action, and persists the key and its metadata to the wrapped keys service.
 * Returns the public key of the random private key, and the PKP address that it was associated with.
 * We don't return the generated wallet address since it can be derived from the publicKey
 *
 * The key will be associated with the PKP address embedded in the `pkpSessionSigs` you provide. One and only one wrapped key can be associated with a given LIT PKP.
 *
 * @param { GeneratePrivateKeyParams } params - Required parameters to generate the private key
 *
 * @returns { Promise<GeneratePrivateKeyResult> } - The publicKey of the generated random private key and the LIT PKP Address associated with the Wrapped Key
 */
async function generatePrivateKey(params) {
    const { pkpSessionSigs, network, litNodeClient, memo } = params;
    if (litNodeClient.config.litNetwork === 'habanero') {
        throw new Error('generatePrivateKey is not available for `habanero`; this feature is still in beta and should not be used for production data yet.');
    }
    const firstSessionSig = (0, utils_2.getFirstSessionSig)(pkpSessionSigs);
    const pkpAddress = (0, utils_2.getPkpAddressFromSessionSig)(firstSessionSig);
    const allowPkpAddressToDecrypt = (0, utils_2.getPkpAccessControlCondition)(pkpAddress);
    const { litActionCode, litActionIpfsCid } = (0, utils_1.getLitActionCodeOrCid)(network, 'generateEncryptedKey');
    const { ciphertext, dataToEncryptHash, publicKey } = await (0, lit_actions_client_1.generateKeyWithLitAction)({
        ...params,
        pkpAddress,
        litActionIpfsCid: litActionCode ? undefined : litActionIpfsCid,
        litActionCode: litActionCode ? litActionCode : undefined,
        accessControlConditions: [allowPkpAddressToDecrypt],
    });
    const { id } = await (0, service_client_1.storePrivateKey)({
        sessionSig: firstSessionSig,
        storedKeyMetadata: {
            ciphertext,
            publicKey,
            keyType: getKeyTypeFromNetwork(network),
            dataToEncryptHash,
            pkpAddress,
            memo,
        },
        litNetwork: litNodeClient.config.litNetwork,
    });
    return {
        pkpAddress,
        id,
        generatedPublicKey: publicKey,
    };
}
exports.generatePrivateKey = generatePrivateKey;
//# sourceMappingURL=generate-private-key.js.map